import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Image } from "antd";
import { CSSTransition } from "react-transition-group";
import Answers from "./Answers";
import Interview from "../assets/svgs/interview.svg";
import Progress from "./Progress";
import { trackEvent } from "../helpers/analytics";

const Question = (props) => {
  const [freeze, setFreeze] = React.useState(false);
  const { answer, error } = useSelector((state) => state);
  const dispatch = useDispatch();

  const handleButtonClick = (question, answer) => {
    props.incrementIndex(question._id, answer.answer);
    setFreeze(false);
    dispatch({ type: "SET_ANSWER", answer: false });
  };
  const getAnswer = (ans) => {
    if (ans.success) {
      setFreeze(true);
      dispatch({ type: "SET_ERROR", error: false });
      dispatch({ type: "SET_ANSWER", answer: ans });
      setTimeout(() => {
        handleButtonClick(props.question, ans);
      }, 1000);
    } else {
      dispatch({ type: "SET_ERROR", error: true });
      dispatch({ type: "SET_ANSWER", answer: ans });
    }
  };

  const getQuestionNumber = (index) => {
    const number = index + 1;
    if (number < 10) {
      return `0${number}`;
    }
    return number.toString();
  }

  useEffect(() => {
    // change page title
    document.title = `Question ${getQuestionNumber(props.index)} of ${getQuestionNumber(props.total)} - UTIRX`;
    trackEvent("step_view", `Question ${getQuestionNumber(props.index)}`, 1);
  }, [props.index]);
  return (
    <>
      <div className="responsive">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {props.index !== 0 && (
            <>
              <p onClick={props.decrementIndex} className="link-button">
                Previous
              </p>
              <p onClick={props.resetQuestion} className="link-button">
                Restart
              </p>
            </>
          )}
        </div>
      </div>
      <div style={{ marginTop: props.index === 0 ? "30px" : "0px" }}>
        {" "}
        <Progress current={props.index} total={props.total} />
      </div>
      <div
        className="flex responsive question-container"
        style={{ justifyContent: "space-between", alignItems: "flex-start" }}
      >
        <div className="interview">
          <Image src={Interview} preview={false} width={"100%"} />
        </div>
        <div className="questions">
          <CSSTransition timeout={1000}>
            <div className={"question"}>
              <span style={{ color: "#0064A9" }}>
                Question {props.index + 1} of {props.total}
              </span>
              <p>{props.question.question}</p>
              {props.question.helper && (
                <p className="helper-message">{props.question.helper}</p>
              )}
              <form>
                {props.question.answers.map((ans, index) => {
                  return (
                    <Answers
                      answer={ans}
                      key={index.toString()}
                      onChange={getAnswer}
                      questionIndex={props.index}
                      selectedAnswer={answer}
                      freeze={freeze}
                    />
                  );
                })}
              </form>
              {error && (
                <small className="error-message">{props.question.error}</small>
              )}
            </div>
          </CSSTransition>
        </div>
      </div>
    </>
  );
};
Question.propTypes = {
  question: PropTypes.shape({
    _id: PropTypes.any,
    question: PropTypes.string,
    helper: PropTypes.string,
    answers: PropTypes.array,
    error: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  incrementIndex: PropTypes.func.isRequired,
  decrementIndex: PropTypes.func,
  resetQuestion: PropTypes.func,
};

export default Question;

